<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">

                <h2 >
                    <span class="fw-300">
                        {{__t('EXPORT_MENU_WORKER')}}
                    </span>
                </h2>

                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show" v-if="cur_step == 'choose_provider'">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="memchik">
                        <div  class="simple_block_menu">
                            <div  class="menu_block">
                                <ul  class="row imc_box" v-if="providers.length > 0">
                                    <li class="mt-3 mb-3 col-md-4 col-xs-6 col-lg-4 col-xl-4 " v-for="provider in providers">
                                        <a href="#" class=" color-primary-500" v-on:click="next_step(provider)">
                                            <div class="menu_item menu_item rounded hover-bg shadow-hover text-center shadow-sm border ">
                                                <div  class="icon">
                                                    <i class="fal fa fa-file-o fa-file" v-if="!provider.hasOwnProperty('icon')"></i>
                                                    <span v-else v-html="provider.icon"></span>
                                                </div>

                                                <div  class="content">
                                                    <h5 class="name">
                                                        {{ provider.name }}
                                                    </h5>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>

            <div class="panel-container show" v-if="cur_step == 'operate_provider'">
                <div class="p-4">
                    <export_worker :provider="this.cur_provider"></export_worker>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer="{close}">

            <div class="modal-footer">
                <button type="button" v-on:click="go_start" class="btn btn-outline-primary waves-effect waves-themed">
                    {{ __t('BACK') }}
                </button>

                <button type="button" v-on:click="close" class="btn btn-outline-primary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>


import Export_worker from "./worker/export_worker.vue";

export default {
    name: "export_modal",
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },

    components : {
        Export_worker

    },

    data() {
        return {
            cur_provider : null,
            cur_step : "choose_provider",
            is_load: false,
            is_show_modal: false,
            can_sync : false,
            tabs : [],
            providers : [],
            aggregators: [],
        }
    },

    created () {
        EventBus.$on("export_menu", this.work_click);
        EventBus.$on("export_menu_close",this.close);
    },

    methods : {

        go_start() {
            this.cur_step = "choose_provider";
        },

        next_step(provider) {
            this.load_provider(provider);
        },

        work_click() {
            this.load_markets();
           // this.load_providers();
        },

        async load_markets() {
            this.is_load = true;

            this.aggregators = [];
            this.providers = [];

            await agr_api.get('/aggregators').then(({data}) => {
                if (data.status === "operation_success") {
                    this.aggregators = data.data;
                    this.load_providers();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position: "b-toaster-top-left"
                })
            });
        },

        async load_provider(provider) {
            this.is_load = true;
            this.cur_provider = provider;
            this.cur_provider.params = {"parameters" :
                    [
                        {
                            'name' : "Url",
                            'type': 'url',
                            "value": ""
                        }
                    ]
            };
            this.cur_step = 'operate_provider';


/*
            await export_api.get('/market-sources/' + provider.type + "/menu/details").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.cur_provider = provider;
                    this.cur_provider.params = data.data;
                    this.cur_step = 'operate_provider';
                }
            }).catch(({response}) => {




                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position: "b-toaster-top-left"
                })
            });*/
        },

        async load_providers() {
            this.providers = [];
            await export_api.get('/market-sources').then(({data}) => {
                this.is_load = false;
                this.is_show_modal = true;

                if (data.status === "operation_success") {
                    data.data.map(item => {

                        let exist_market = this.aggregators.find(a => a.type === item.type);
                        if(this.obj_to_null(exist_market)) {
                            item.icon = exist_market.icon;
                            this.providers.push(item);
                        }
                    });

                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position: "b-toaster-top-left"
                })
            });
        },


        close() {
            this.aggregators = [];
            this.providers = [];

            this.cur_step = "choose_provider";
            this.is_show_modal = false;
        },

    },

    computed : {

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>


<style scoped>

</style>
